<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.left_right_selection">
  <div class="row" *ngIf="wrapper">
    <div class="col-6">
      <div class="row freeze_height">
        <div class="col-6">
          <button type="button" style="width:100%;height:100%;" class="btn btn-secondary" (click)="onClick(1)">{{localService.languageContent.left_right_selection.move_selection_to_right}}</button>
        </div>
        <div class="col-6">
          <button type="button" style="width:100%;height:100%;" class="btn btn-secondary" (click)="onClick(2)">{{localService.languageContent.left_right_selection.move_all_to_right}}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="banner custom_rows_body" style="margin-top:10px;" [ngStyle]="{'height' : maxBodyHeight + 'px'}">
            <div *ngFor="let item of wrapper.source">
              <div class="row styled_row" *ngIf="!(wrapper.selected.indexOf(item.key) > -1)">
                <label style="font-weight: normal;">
                  <input type="checkbox" [(ngModel)]="item.isSelected" />
                  <span class="normal_color">{{item.value}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="row">
        <div class="col-6">
          <button type="button" style="width:100%;height:100%;" class="btn btn-secondary" (click)="onClick(3)">{{localService.languageContent.left_right_selection.move_selection_to_left}}</button>
        </div>
        <div class="col-6">
          <button type="button" style="width:100%;height:100%;" class="btn btn-secondary" (click)="onClick(4)">{{localService.languageContent.left_right_selection.move_all_to_left}}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="banner custom_rows_body" style="margin-top:10px;" [ngStyle]="{'height' : maxBodyHeight + 'px'}">
            <div *ngFor="let item of destination">
              <div class="row styled_row" *ngIf="wrapper.selected.indexOf(item.key) > -1">
                <label style="font-weight: normal;">
                  <input type="checkbox" [(ngModel)]="item.isSelected" />
                  <span class="normal_color">{{item.value}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
